import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const fetchLendingDisbursementPaymentOptions = gql`
  query LendingDisbursementPaymentOptions(
    $input: LendingDisbursementPaymentOptionsInput!
  ) {
    lendingDisbursementPaymentOptions(input: $input) {
      __typename
      ... on LendingDisbursementPaymentOptionsSuccess {
        __typename
        options {
          ... on LendingDisbursementPaymentOption {
            __typename
            details {
              __typename
              ... on LendingPaymentOptionDetails {
                __typename
                accountId
                name
                maskedAccountNumber
                balance {
                  __typename
                  amount
                  currency
                  formatted
                }
                network
                source
                icon {
                  ... on URLType {
                    __typename
                    url
                  }
                  ... on VXLIconType {
                    __typename
                    key
                  }
                }
              }
            }
            displayGroup
          }
        }
        showLinkAccount
        showLinkDebitCard
        showLinkDebitCardSheet
      }
      ... on LendingDisbursementPaymentOptionsError {
        ...error
      }
    }
  }
  ${error}
`;

export default fetchLendingDisbursementPaymentOptions;
